import { render, staticRenderFns } from "./AssetDepreciation.vue?vue&type=template&id=4f8905fc&scoped=true"
import script from "./AssetDepreciation.vue?vue&type=script&lang=js"
export * from "./AssetDepreciation.vue?vue&type=script&lang=js"
import style0 from "./AssetDepreciation.vue?vue&type=style&index=0&id=4f8905fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8905fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8905fc')) {
      api.createRecord('4f8905fc', component.options)
    } else {
      api.reload('4f8905fc', component.options)
    }
    module.hot.accept("./AssetDepreciation.vue?vue&type=template&id=4f8905fc&scoped=true", function () {
      api.rerender('4f8905fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Asset/AssetDepreciation/AssetDepreciation.vue"
export default component.exports